import React, { useEffect, useState } from 'react';
import { getOperationStatus, invalidateOperationCache } from '../services/OperationTimeService';
import useTranslation from '../hooks/useTranslation';

interface MaintenancePageProps {
  onServiceReady: () => void;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ onServiceReady }) => {
  const { t } = useTranslation();
  const [dots, setDots] = useState('');

  // 점 애니메이션 효과
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => {
        if (prev === '...') return '';
        return prev + '.';
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  // 주기적으로 서비스 상태 확인
  useEffect(() => {
    const checkService = async () => {
      // Figma html-to-design: 캡처 중에는 복구 시 홈으로 보내지 않음(프레임이 홈으로 바뀌는 것 방지)
      if (
        typeof window !== 'undefined' &&
        (window.location.hash.includes('figmacapture') ||
          window.location.search.includes('figmacapture'))
      ) {
        return;
      }
      try {
        // 캐시 무효화 후 새로운 상태 확인
        invalidateOperationCache();
        const status = await getOperationStatus();
        if (status.isOpen) {
          onServiceReady();
        }
      } catch (error) {
        // 계속 확인
      }
    };

    // 즉시 한 번 확인
    checkService();

    // 10초마다 확인 (5초에서 증가)
    const interval = setInterval(checkService, 10000);

    return () => clearInterval(interval);
  }, [onServiceReady]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        {/* 로딩 애니메이션 */}
        <div className="w-16 h-16 mx-auto mb-6 relative">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-red-500"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm0 2a10 10 0 110-20 10 10 0 010 20z" clipRule="evenodd" opacity="0.2" />
            </svg>
          </div>
        </div>

        {/* 메인 메시지 */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {t('maintenance.title')}
        </h1>

        {/* 설명 메시지 */}
        <p className="text-gray-600 mb-6 leading-relaxed">
          {t('maintenance.message')}
        </p>

        {/* 진행 상태 표시 */}
        <div className="text-red-500 font-medium">
          {t('maintenance.checking')}{dots}
        </div>

        {/* 예상 시간 안내 */}
        <p className="text-sm text-gray-400 mt-6">
          {t('maintenance.expectedTime')}
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage; 